/**
 * Response-cache keys for the read-only enriched DTOs served via readThrough.
 * Centralized so the inspection screen (which reads) and the login warm-up
 * (which pre-populates) use byte-identical keys — otherwise a warmed entry
 * wouldn't be found offline.
 */
export const ck = {
  inspection: (id: number, userId: number | null) => `inspection:${id}:${userId}`,
  questions: (id: number, userId: number | null, role: string | null, rank: string | null) =>
    `inspection-questions:${id}:${userId}:${role}:${rank}`,
  summary: (id: number, userId: number | null, role: string | null, rank: string | null) =>
    `inspection-summary:${id}:${userId}:${role}:${rank}`,
  /** Stored preparation guides for the questions this user sees. */
  prep: (id: number, userId: number | null) => `inspection-prep:${id}:${userId}`,
};
